import React, { useState } from 'react'
// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";


const SessionButtons = ({ Session }) => {


  return (
    <div className="mb-3 col-md-12">
      <div className="card">
        <Card sx={{ height: "100%", boxShadow: !false && "none" }}>
          <MDBox display="flex" py={1} pr={2}>

            <button className='btn btn-outline-dark mx-2'>Accounting Entries</button>
            <button className='btn btn-outline-dark mr-2'>Accounting Sessions</button>
            <button className='btn btn-outline-dark mr-2'>Appointments</button>
            <button className='btn btn-outline-dark mr-2'>Therapists</button>
            <button className='btn btn-outline-dark mr-2'>Patients</button>
          </MDBox>
        </Card>
      </div>
    </div>
  )
}

export default SessionButtons